import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GiftOutlined, RiseOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { readPrimaryUserData } from "../../utils/activeProfileStorage";
import { hydrateGamification } from "../../utils/gamificationSlice";
import { getGamificationConfig } from "../../utils/gamificationService";
import "./AppSubheader.scss";

const AppSubheader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const balance = useSelector((s: any) => s.gamification?.balance ?? 0);
  const cfg = getGamificationConfig();
  const [collapsed, setCollapsed] = useState(
    () => typeof document !== "undefined" && document.body.classList.contains("sidebar-collapse")
  );

  const primary = readPrimaryUserData();
  const userId = primary?.userId ?? primary?.id;

  useEffect(() => {
    if (userId) dispatch(hydrateGamification(String(userId)));
  }, [dispatch, userId, location.pathname]);

  useEffect(() => {
    const obs = new MutationObserver(() => {
      setCollapsed(document.body.classList.contains("sidebar-collapse"));
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => obs.disconnect();
  }, []);

  return (
    <div
      className={`app-subheader${collapsed ? " app-subheader--collapsed" : ""}`}
      aria-label="Rewards strip"
    >
      <div className="app-subheader__inner">
        <div className="app-subheader__lead">
          <span className="app-subheader__spark" aria-hidden>
            ✨
          </span>
          <div>
            <div className="app-subheader__title">Rewards & progress</div>
            <div className="app-subheader__subtitle">
              Every login adds <strong>+1</strong> {cfg.currencyLabel?.toLowerCase() || "coin"} · Complete tasks to earn more
            </div>
          </div>
        </div>

        <div className="app-subheader__actions">
          <button
            type="button"
            className="app-subheader__pill"
            onClick={() => navigate("/coin-wallet")}
          >
            <span className="app-subheader__pill-icon" aria-hidden>
              🪙
            </span>
            <div className="app-subheader__pill-text">
              <span className="app-subheader__pill-label">Balance</span>
              <span className="app-subheader__pill-value">{balance}</span>
            </div>
            <RiseOutlined className="app-subheader__pill-chev" />
          </button>

          <button
            type="button"
            className="app-subheader__cta"
            onClick={() => navigate("/coin-wallet")}
          >
            <GiftOutlined />
            <span>Redeem</span>
            <ArrowRightOutlined />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppSubheader;
